import React from "react";
import { TextInput } from "../../component/styled";

const AddressField = ({ label, address, detailAddress, onChange, buttonEvent }) => (
  <li className="address">
    <span className="tit">{label}</span>
    <div className="cont">
      <TextInput type="text" placeholder="주소" value={address} readOnly />
      <button type="button" onClick={() => buttonEvent()}>
        주소찾기
      </button>
      <TextInput
        type="text"
        name="detailAddress"
        placeholder="상세 주소"
        value={detailAddress}
        onChange={onChange}
      />
    </div>
  </li>
);

export default AddressField;
